module.exports = __webpack_public_path__ + "media/customizations/lewiscommunities/logo-738b7ec982b6630fcefe0147bfa3d8dd.png";